import type {
  ChargeMethod,
  NoneableChargeMethod,
  PackageSource,
} from '@mntn-dev/domain-types'
import { ChargeMethodEnum, PackageSourceEnum } from '@mntn-dev/domain-types'

export type SourceMethodPair = readonly [PackageSource, ChargeMethod]

export const hasPair = (
  list: readonly SourceMethodPair[],
  packageSource: PackageSource,
  billingMethod: ChargeMethod | NoneableChargeMethod
): boolean =>
  list.some(
    ([source, method]) => source === packageSource && method === billingMethod
  )

export const CreditBasedPairs = [
  [PackageSourceEnum.linkedin, ChargeMethodEnum.linkedin],
  [PackageSourceEnum.meta, ChargeMethodEnum.meta],
  [PackageSourceEnum.tiktok, ChargeMethodEnum.tiktok],
  [PackageSourceEnum.ctv, ChargeMethodEnum.mntn_credits],
] as const satisfies readonly SourceMethodPair[]

export const MoneyBasedPairs = [
  [PackageSourceEnum.ctv, ChargeMethodEnum.invoice],
  [PackageSourceEnum.ctv, ChargeMethodEnum.stripe],
  [PackageSourceEnum.ctv, ChargeMethodEnum.ams],
  [PackageSourceEnum.quickframe, ChargeMethodEnum.invoice],
  [PackageSourceEnum.quickframe, ChargeMethodEnum.stripe],
  [PackageSourceEnum.quickframe, ChargeMethodEnum.ams],
] as const satisfies readonly SourceMethodPair[]

export const CreditsFirstThenDollarsPairs = [
  [PackageSourceEnum.ctv, ChargeMethodEnum.mntn_credits],
] as const satisfies readonly SourceMethodPair[]

export const AddOnDollarPairs = [
  ...CreditBasedPairs,
  ...MoneyBasedPairs,
] as const satisfies readonly SourceMethodPair[]
